$(document).ready(function () {
  $(document).on('click', '.title-click-to-scroll-to-brand-info', function () {
    if ($('.brand-info-section-to-scroll-till').length) {
      var moveToBrandSectionTop = 150;
      if (document.documentElement.clientWidth  <= 991) {
         var moveToBrandSectionTop = 100;
      }
      $('html').animate({
          scrollTop: $('.brand-info-section-to-scroll-till').offset().top - moveToBrandSectionTop
      }, 1000);
    }
  });
});


